import { type MachineType } from "@packsize/schemas/machines";
import { defineMessages, type IntlShape, type MessageDescriptor } from "react-intl";
import { getLocalizedMessage } from "./base";

const machineTypeMessages: Record<MachineType, MessageDescriptor> = defineMessages<MachineType, MessageDescriptor>({
	CVPRange: {
		id: "CVPRange",
		defaultMessage: "CVP Range",
	},
	SealProX: {
		id: "SealProX",
		defaultMessage: "SealPro X",
	},
	Em: {
		id: "Em",
		defaultMessage: "EM",
	},
	Fusion: {
		id: "Fusion",
		defaultMessage: "Fusion",
	},
	X4: {
		id: "X4",
		defaultMessage: "X4",
	},
	X5: {
		id: "X5",
		defaultMessage: "X5",
	},
	X6: {
		id: "X6",
		defaultMessage: "X6",
	},
	X7: {
		id: "X7",
		defaultMessage: "X7",
	},
	X5wPrint: {
		id: "X5wPrint",
		defaultMessage: "X5 with Print",
	},
	ZebraPrinter: {
		id: "ZebraPrinter",
		defaultMessage: "Zebra Printer",
	},
	LantechCaseSealer: {
		id: "LantechCaseSealer",
		defaultMessage: "ClosePro X",
	},
	PL1: {
		id: "PL1",
		defaultMessage: "LidPro X",
	},
	Everest: {
		id: "Everest",
		defaultMessage: "CVP Everest",
	},
	Impack: {
		id: "Impack",
		defaultMessage: "CVP Impack",
	},
});

export const getLocalizedMachineType = (machineType: MachineType, intl: IntlShape) => {
	const descriptor = machineTypeMessages[machineType];

	return getLocalizedMessage(machineType, descriptor, intl);
};
